import React from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import Navigation from "./Navigation";

import useWindowProps from "./hooks/useWindowProps";

import TopBar from "./components/TopBar";

import "./App.css";
import img1 from "./assets/isologo.svg"
import { config } from './config';
import Maintenance from './screens/Maintenance';

const backgroundImage = `url(${img1})`;

declare module "styled-components" {
  export interface DefaultTheme {
    colors: { [index: string]: string };
  }
}

const GlobalStyle = createGlobalStyle`
  body {
    font-family: "Figtree", serif;
    background: #fafafa;
    padding: 0;
    margin: 0;
    background-color: #fff000;
    overflow-x: hidden;
  }
`;

const theme = {
  colors: {
    primary: "#4EEC91",
    background: "#fff000",
    // background: backgroundImage,
    basic100: "#fff",
    basic150: "#fafafa",
    basic300: "#d1d1d1",
    basic400: "#999",
    basic500: "#666",
    basic1000: "#3d3d3d",
    basic2000: "#111827",
  },
};

type WrapperProps = {
  height: number;
};

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background};
  overflow-x: hidden;
`;

const ScreenWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.basic100};
  width: 105%;
  border-radius: 40px;
  border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;

  @media (min-width: 767px) {
    width: 70%;
    border-radius: 30px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  @media (min-width: 1024px) {
    width: 40%;
    border-radius-: 30px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

const App: React.FC = () => {
  const windowProps = useWindowProps();

  if (config.maintenance.enabled) {
    return <Maintenance />;
  }

  return (
    <HelmetProvider>
      <BrowserRouter>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
          <Wrapper height={windowProps.height}>
            <TopBar />
            <ScreenWrapper>
              <Navigation />
            </ScreenWrapper>
          </Wrapper>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
